module.exports = __webpack_public_path__ + "static/img/ic-top-teamwork.74b3edd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/ic-top-teamwork.png
// module id = Bt95
// module chunks = 1